// ai-prefs.ts — localStorage toggle for AI features.
// Pattern matches app-prefs.ts: try/catch, device-local only, not synced.
// AI is OFF by default; user must explicitly enable in Settings.

const AI_ENABLED_KEY = "personal-life-os:ai-enabled";

/**
 * Returns true when the user has opted in to AI features.
 * Falls back to false (safe default) on any localStorage error.
 */
export function isAiEnabled(): boolean {
  try {
    return localStorage.getItem(AI_ENABLED_KEY) === "1";
  } catch {
    return false;
  }
}

/**
 * Persist the AI-enabled preference.
 * Silently swallows quota / private-browsing errors.
 */
export function setAiEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(AI_ENABLED_KEY, enabled ? "1" : "0");
  } catch {
    // Quota exceeded or private browsing — ignore.
  }
}
